import React from 'react';

import {
  EmailTemplateHtmlPreviewType,
  useCreateTemplateFromSampleMutation,
  useCreateTemplateMutation,
  useSampleWaypointTemplatesQuery,
} from '@dashboard/generated/wp/platform';
import { useShowTemplateNavigate } from '@dashboard/hooks/navigate/usePlatformNavigator';
import { Box } from '@mui/material';

import SampleTemplateCard from '../SampleTemplateCard';

type Props = {
  close: () => void;
};
export default function SamplesList({ close }: Props) {
  const { data } = useSampleWaypointTemplatesQuery();
  const [createEmptyTemplate, { loading: loadingEmpty }] = useCreateTemplateMutation();
  const [createTemplateFromSample, { loading: loadingSample }] = useCreateTemplateFromSampleMutation();

  const showTemplate = useShowTemplateNavigate();

  const onCreateEmptyTemplate = async () => {
    const { data } = await createEmptyTemplate();
    close();
    if (data?.createTemplate.id) {
      showTemplate(data.createTemplate.id);
    }
  };

  const onCreateSampleTemplate = async (sampleTemplateId: string | null) => {
    if (!sampleTemplateId) {
      return;
    }
    const { data } = await createTemplateFromSample({ variables: { sampleTemplateId } });
    close();
    if (data?.createTemplateFromSample.id) {
      showTemplate(data.createTemplateFromSample.id);
    }
  };

  const nodes = data?.SampleWaypointTemplates.nodes ?? [];
  const loadingMutation = loadingEmpty || loadingSample;
  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
      <SampleTemplateCard
        title="Empty template"
        onClick={onCreateEmptyTemplate}
        disabled={loadingMutation}
        templateId={null}
        templateType={EmailTemplateHtmlPreviewType.Template}
      />
      {nodes.map((n, i) => (
        <SampleTemplateCard
          key={i}
          title={n.name}
          templateId={n.id}
          templateType={EmailTemplateHtmlPreviewType.Sample}
          onClick={onCreateSampleTemplate}
          disabled={loadingMutation}
        />
      ))}
    </Box>
  );
}
